export default defineNuxtRouteMiddleware(async (to) => {
  // skip middleware on server
  if (import.meta.server) { return }

  const app = useNuxtApp()
  const userAuthStore = useUserAuthStore(app.$pinia)

  if (userAuthStore.role === 0 && to.fullPath !== '/') {
    const { data, status } = await useLoginValidateGet()

    if (status.value !== 'success') {
      return navigateTo('/')
    }

    userAuthStore.setAuth({
      username: data.value?.username || '',
      role: data.value?.role || 0,
    })

    if (to.fullPath === '/') {
      return navigateTo('/stock/alat-berat')
    }
  }

  if (to.fullPath === '/') { return }

  if (userAuthStore.role === 3) {
    if (!ROLE_PATHS[3].test(to.fullPath)) { return navigateTo('/rent') }
  }

  if (userAuthStore.role === 4) {
    if (!ROLE_PATHS[4].test(to.fullPath)) { return navigateTo('/rent') }
  }
})
